import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class ContinualImprovementProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'continualImprovement'}
            title={ t('support.procedure.P15.title') }
            exportTitle={ t('support.procedure.P15.exportTitle') }
            exportFileName={'continualImprovement.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (ContinualImprovementProcedure);
